import { tns } from 'tiny-slider/src/tiny-slider';

class MediaContentSlider {
	constructor(el, controls) {
		this.el = el;
		this.controls = controls;

		const mediaContentSlider = tns({
			container: this.el,
			autoplay: false,
			autoplayButtonOutput: false,
			mouseDrag: true,
			preventScrollOnTouch: 'auto',
			swipeAngle: false,
			speed: 400,
			nav: false,
			controls: true,
			controlsContainer: this.controls,
		});

		return mediaContentSlider;
	}
}

export default MediaContentSlider;